import React from 'react';
import { Heading } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import CheckInInfo from 'components/PropertyPage/CheckInInfo';
import Markdown from 'components/Markdown/Markdown';

const PropertyDescription = ({ property }) => (
  <>
    <Heading.h4>Getting there</Heading.h4>
    <CheckInInfo property={property} mb={6} />
    <Markdown content={property.description} disableParsingRawHTML={false} />
  </>
);

PropertyDescription.propTypes = {
  property: PropTypes.shape({
    description: PropTypes.string,
    checkInAfter: PropTypes.string,
    checkOutBefore: PropTypes.string,
  }).isRequired,
};

export default PropertyDescription;
